import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublicLayout from '@/components/PublicLayout';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <PublicLayout>
      <div className="max-w-3xl mx-auto px-4 py-32 text-center">
        <p className="text-xs tracking-[0.3em] uppercase text-[color:var(--gold)] mb-3">404</p>
        <h1 className="font-heading text-4xl md:text-5xl mb-4">{t('common.notFound')}</h1>
        <Link to="/"><Button data-testid="notfound-back-home" className="bg-[color:var(--gold-strong)] text-black hover:bg-[#C6A21A]">{t('common.backHome')}</Button></Link>
      </div>
    </PublicLayout>
  );
}
